import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Account Preferences</h3>
                <p className="text-sm text-gray-600">
                    Customize the global settings for your fleet management workspace.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Units and Measurements</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Distance:</strong> Choose between Kilometers and Miles.</li>
                    <li><strong>Fuel Volume:</strong> Select Liters or Gallons.</li>
                    <li><strong>Pressure:</strong> Set your preferred unit for tire pressure tracking.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Regional Settings</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Currency:</strong> Set the default currency for all expense and fuel logs.</li>
                    <li><strong>Time Zone:</strong> Ensure all timestamps are displayed correctly for your location.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Saving Changes</h4>
                <p className="text-sm text-gray-600">
                    Changes made in the preferences section update your workspace attributes immediately to ensure consistency across all modules.
                </p>
            </section>
        </div>
    );
};

export default Help;
